import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { LogoMark } from "@/components/Logo";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();
  const [error, setError] = useState(null);
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      setError("Parametro di sessione mancante.");
      return;
    }
    loginWithGoogle(sessionId)
      .then(() => navigate("/area-riservata", { replace: true }))
      .catch((e) => setError(formatApiError(e)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center navy-mesh" data-testid="auth-callback">
      <div className="card-surface mx-4 flex max-w-md flex-col items-center rounded-2xl p-10 text-center">
        <LogoMark size={48} />
        {error ? (
          <>
            <p className="mt-6 font-serif text-xl text-slate-100">Accesso non riuscito</p>
            <p className="mt-3 text-sm font-light leading-relaxed text-red-300" data-testid="auth-callback-error">{error}</p>
            <button
              onClick={() => navigate("/area-riservata", { replace: true })}
              data-testid="auth-callback-back-btn"
              className="mt-6 rounded-full border border-gold/40 px-6 py-2.5 text-sm text-gold transition-colors hover:bg-gold/10"
            >
              Torna al login
            </button>
          </>
        ) : (
          <p className="mt-6 font-mono text-sm text-slate-400" data-testid="auth-callback-loading">
            Accesso con Google in corso…
          </p>
        )}
      </div>
    </main>
  );
}
